<template>
  <div class="goods-attr">
    <!-- 浮窗顶部 -->
    <div class="attr-header">
      <div class="goods-image" :style="{height:imageHeight}">
        <img :src="goods.thumb || notfoundimage" />
      </div>
      <div class="right-close-btn">
        <van-button class="new-back-btn" icon="arrow-left" size="small" plain type="danger" @click="closePopup">Back</van-button>
      </div>

      <div ref="posTop" class="pos-top">
        <!-- <div class="right-close-btn" v-if="goods.goods_attr_list.length || goods.isEdit"> -->
        <div class="flex flex-start justify-between">
          <div class="item-name">{{goods.title}}</div>
          <div class="item-price">
            <span>{{ fmPrice(goods.price || goods.marketprice)}}</span>
            <div v-if="goods.goods_attr_list.length" class="base-price">Base price</div>
          </div>
        </div>
        <div class="item-desc">
          <p>{{goods.description || ''}}</p>
        </div>
      </div>
    </div>

    <div v-if="goods.isoptions == 1" class="attr-body">
      <!-- 属性列表 -->
      <div class="item-attr" v-for="(attr, index) in attrList" :key="index">
        <!-- 属性标题 -->
        <div v-if="attr.items[0]['ov_status']==1" class="attr-title">{{attr.title}} <span v-if="attr.items[0]['is_required']==1" class="attr-required">*</span></div>
        <div v-if="attr.items[0]['ov_status']==1" class="attr-list">
          <AddonsRadio v-if="attr.items[0]['is_multiple']==0" :arrItems="attr.items" :strName="attr.title" @evtChooseAttr="chooseAttr" />
          <AddonsCheckbox v-if="attr.items[0]['is_multiple']==1" :arrItems="attr.items" :strName="attr.title" @evtChooseAttr="chooseAttrCheckbox" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { cartMixin } from "@/mixins/cartMixin";
import AddonsRadio from "./AddonsRadio";
import AddonsCheckbox from "./AddonsCheckbox";
// <GoodsAddons :arrItems="attr.items" @evtChooseAttr="chooseAttr"/>
export default {
  props: {
    // 当前商品
    goods: {
      type: Object,
      default: () => {
        return {
          title: "",
          name: "",
          price: 0
        };
      }
    },
    //当前[item]所有的属性列表
    attrList: {
      type: Array,
      default: () => {
        return new Array();
      }
    },
    //当前已选中的属性列表
    chooseList: {
      type: Array,
      required: false,
      default: () => {
        return new Array();
      }
    }
  },
  data () {
    return {
      radio: {
        item0: "",
        item1: "",
        item2: "",
        item3: "",
        item4: "",
        item5: "",
        item6: "",
        item7: "",
        item8: "",
        item9: ""
      },
      curAttr: {},
      mulAttr: [],
      notfoundimage:
        "https://restaurant.fastorder.my/attachment/images/2/2020/01/rhfi799j4R9I4RPrKH9357Zwz8jIPi.jpg",
      imageHeight: "150px",
      requiredOptionList: {} //所有必选项的状态
    };
  },
  components: {
    AddonsRadio,
    AddonsCheckbox
  },
  created () {
    this.mulAttr = [];
    if (this.chooseList.length) {
      this.mulAttr = this.chooseList;
      // console.log('来自购物车item已选中的规格', this.mulAttr);
    }
    this.getScreenSize(0.3);
    this.iniGoods()
  },
  mixins: [cartMixin],
  methods: {
    iniGoods () {
      let listOption = {} //初始化所有的option的值, 其中 is_required=0 时默认值为 true
      this.attrList && this.attrList.length && this.attrList.forEach(item => {
        listOption[item.title] = false
        item.items && item.items.length > 0 && item.items.forEach(im => {
          listOption[item.title] = im.is_required == 0
        })
      })
      this.chooseList && this.chooseList.forEach(item => {
        const kkname = Object.keys(item)[0]
        if (item.optionid != "") {
          listOption[kkname] = true
        }
      })
      this.requiredOptionList = listOption
      this.checkRequiredOptionList()
    },
    checkRequiredOptionList () {
      //检查所有option是否都为true,并抛出emit事件上层组件
      const listVal = Object.values(this.requiredOptionList)
      let reqVal = true
      if (this.goods.isoptions == 1){
        listVal && listVal.length > 0 && listVal.forEach(item => {
          if (item == false) {
            reqVal = false
          }
        }) 
      }
      console.log('emit------------', reqVal);
      setTimeout(() => {
        this.$emit("evtIsRequired", reqVal)
      }, 200);
    },
    /**
     * 获取相对于屏幕的高度
     * @param {屏幕高度的百分比} size_num
     */
    getScreenSize (size_num) {
      size_num = size_num <= 0 ? 1 : size_num;
      const h =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight;
      const imagehpx = parseInt(h * size_num) + "px";
      this.imageHeight = imagehpx;
    },
    closePopup () {
      this.$emit("evtClosePopup");
    },
    chooseAttr (newAttr, addon_name, bool_val) {
      this.requiredOptionList[addon_name] = bool_val
      this.attrList && this.attrList.forEach(atm => {
        if (atm.title == addon_name && atm.items[0].is_required == 0) {
          this.requiredOptionList[addon_name] = true
        }
      })

      const delTodo = () => {
        // 从 mulAttr 中查找和删除同规格的内容
        let afterDelAddon = [];
        this.mulAttr && this.mulAttr.length && this.mulAttr.forEach(mitem => {
          let is_exist = false;
          Object.keys(mitem).forEach(kname => {
            if (kname === addon_name) {
              is_exist = true;
            }
          });
          if (is_exist === false) {
            afterDelAddon.push(mitem);
          }
        });
        this.mulAttr = afterDelAddon;
      };
      delTodo();
      if (bool_val) {
        this.mulAttr.push(newAttr);
      }
      if (this.mulAttr.length < 1) {
        this.checkMulAttr()
        this.$emit("evtChooseAttr0", { sku: this.goods.sku, sky: this.goods.sky, attr: [] });
      } else {
        this.checkMulAttr()
        this.$emit("evtChooseAttr0", { sku: this.goods.sku, sky: this.goods.sky, attr: this.mulAttr });
      }
    },
    existAttr (addon_name) {
      //检查规格[addon_name]在当前的[mulAttr]是否存在
      let exist_val = false
      this.mulAttr && this.mulAttr.length && this.mulAttr.forEach((item, index) => {
        const ikList = Object.keys(item)
        if (ikList.includes(addon_name) === true) {
          exist_val = true
        }
      })
      return exist_val
    },
    delCheckboxExistAttr (addon_name) {
      //过滤掉已存在的规格， checkbox是有效
      const filterRes = this.mulAttr && this.mulAttr.length && this.mulAttr.filter(im => {
        const imKeys = Object.keys(im)
        if (imKeys.includes(addon_name) == false) {
          return im
        }
      })
      return filterRes
    },
    chooseAttrCheckbox (newAttr, addon_name, bool_val) {
      const isExist = this.existAttr(addon_name)
      let filterRes = this.delCheckboxExistAttr(addon_name)
      this.requiredOptionList[addon_name] = newAttr.length ? true : false
      this.attrList && this.attrList.forEach(atm => {
        if (atm.title == addon_name && atm.items[0].is_required == 0) {
          this.requiredOptionList[addon_name] = true
        }
      })

      if (bool_val) {
        if (this.mulAttr.length < 1) {
          this.mulAttr = newAttr;
        } else {
          newAttr.forEach(im => filterRes.push(im))
          this.mulAttr = filterRes
        }
      }
      if (this.mulAttr.length < 1) {
        this.checkMulAttr()
        this.$emit("evtChooseAttr0", { sku: this.goods.sku, sky: this.goods.sky, attr: [] });
      } else {
        this.checkMulAttr()
        this.$emit("evtChooseAttr0", { sku: this.goods.sku, sky: this.goods.sky, attr: this.mulAttr });
      }
    },
    checkMulAttr () {
      console.log('检测结果1111111', this.requiredOptionList);
      console.log('检测结果2222222', Object.values(this.requiredOptionList));
      this.checkRequiredOptionList()
    }
  }
};
</script>
<style lang="less">
@import url('../../assets/css/common.less');
.goods-attr {
  background-color: white;
  .attr-required {
    color: @red;
    font-size: 16px;
  }
  .attr-header {
    // position: fixed;
    // left: 0;
    // right: 0;
    // top: 0;
    // z-index: 3000;
    background-color: white;
    .goods-image {
      width: 100%;
      margin: 0 0 0 0;
      padding: 0;
      overflow: hidden;
      img {
        width: 100%;
      }
    }
    .right-close-btn {
      text-align: left;
      padding: 0;
      line-height: 10px;
      margin-bottom: 10px;
      position: absolute;
      top: 10px;
      left: 10px;
      .new-back-btn {
        border: 0;
        background-color: rgba(0, 0, 0, 0.38);
        color: white;
      }
    }
    .pos-top {
      padding: 15px 8px 0px 8px;
      text-align: left;
      background-color: #ffffff;
      position: relative;
      top: -22px;
      border-radius: 20px 20px 0 0;

      .item-name {
        font-weight: bold;
        font-size: 18px;
      }
      .close-icon {
        font-weight: normal;
        padding: 5px 5px;
        background-color: rgba(255, 255, 255, 0.38);
        border-radius: 100%;
        margin-right: 13px;
      }
      .item-price {
        padding: 0 0 0 8px;
        font-weight: bold;
        font-size: 20px;
        .base-price {
          width: 60px;
          font-size: 12px;
          color: #666666;
          font-weight: normal;
        }
      }
      .item-desc {
        font-size: 12px;
        color: #666666;
        font-weight: normal;
        p {
          margin: 10px 0 0 0;
          padding: 0;
        }
      }
    }
  }
  .attr-body {
    padding: 0px 0 200px 0;
    // background-color: #f0f0f0;
    text-align: left;
    .item-attr {
      padding: 0 10px 10px 10px;
      background-color: white;
      margin: 0 0 10px 0;
      .attr-price {
        text-align: center;
      }
      .attr-title {
        margin-bottom: 10px;
        font-weight: 550;
      }
    }
  }
}
</style>